export * from './ClientData';
export * from './ClientResponse';
export * from './ProgressEvent';
export * from './SpeedtestType';
export * from './SpeedTestOrigin';
export * from './Measurement';
export * from './DataPublisher';
export * from './WebWorkerTypings';
export * from './LocateResponse';
export * from './SpeedtestConfig'